import ReopenBoxSuccess from './ReopenBoxSuccess';

export default ReopenBoxSuccess;
